import { useEffect, useState } from "react";
import { NAV } from "./data";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-300 ${
        scrolled ? "bg-background/80 backdrop-blur-xl border-b border-foreground/10 py-4" : "bg-transparent py-6"
      }`}
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 flex items-center justify-between">
        <button data-testid="brand-logo" onClick={() => go("#hero")} className="flex items-center gap-2 group">
          <span className="h-2.5 w-2.5 rounded-full bg-primary transition-transform duration-300 group-hover:scale-125" />
          <span className="font-serif text-xl tracking-tight text-foreground">Align Enrollment</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              onClick={() => go(n.href)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => go("#contact")}
          className="hidden md:inline-flex items-center rounded-full bg-primary px-6 py-2.5 text-sm text-primary-foreground transition-transform duration-200 hover:-translate-y-0.5"
        >
          Get Started
        </button>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-foreground" onClick={() => setOpen(!open)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden mt-4 mx-6 rounded-2xl border border-foreground/10 bg-background/95 backdrop-blur-xl p-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <button key={n.href} onClick={() => go(n.href)} className="text-left font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
              {n.label}
            </button>
          ))}
          <button onClick={() => go("#contact")} className="rounded-full bg-primary px-6 py-3 text-sm text-primary-foreground">
            Get Started
          </button>
        </div>
      )}
    </header>
  );
}
